import { GUI } from 'three/addons/libs/lil-gui.module.min.js';

let gui = null;
let networkParams = null;

let communicationParams = null;

let viewerParams = null;

export function initAnalytics(analyticsPanelID) {

    gui = new GUI({ autoPlace: false, title: "Linkroom KPIs" });
    var analyticsPanel = document.getElementById(analyticsPanelID);
    if (analyticsPanel != null) {
        analyticsPanel.appendChild(gui.domElement);
    }

    networkParams = {
        sendRate: 0,
        sendPeak: 0,
        receiveRate: 0,
        receivePeak: 0
    };

    communicationParams = {
        duration: 0,
        RTT: 0,
        recvBitrate: 0,
        recvBytes: 0,
        sendBitrate: 0,
        sendBytes: 0,
        userCount: 0
    }

    viewerParams = {
        sceneObjectsAmount: 0,
        hiddenSceneObjects: 0,
        linkpadsAmount: 0,
        hiddenLinkpads: 0
    }

    let networkingFolder = gui.addFolder('Network');

    networkingFolder.add(networkParams, 'sendRate', 0, 200).name('Send Rate (msg/s)').listen();
    networkingFolder.add(networkParams, 'sendPeak', 0, 500).name('Send Peak (msg/s)').listen();
    networkingFolder.add(networkParams, 'receiveRate', 0, 200).name('Receive Rate (msg/s)').listen();
    networkingFolder.add(networkParams, 'receivePeak', 0, 500).name('Receive Peak (msg/s)').listen();

    let communicationFolder = gui.addFolder('Communication');
    communicationFolder.add(communicationParams, 'duration', 0, 1000000).name('Session Time ').listen();
    communicationFolder.add(communicationParams, 'RTT', 0, 1000000).name('Latency RTT').listen();
    communicationFolder.add(communicationParams, 'recvBitrate', 0, 1000000).name('Received Rate KBs').listen();
    communicationFolder.add(communicationParams, 'recvBytes', 0, 1000000).name('Total Received KB').listen();
    communicationFolder.add(communicationParams, 'sendBitrate', 0, 1000000).name('Sent Rate KBs').listen();
    communicationFolder.add(communicationParams, 'sendBytes', 0, 1000000).name('Total Sent KB').listen();
    communicationFolder.add(communicationParams, 'userCount', 0, 1000000).name('Active Users').listen();

    let sceneObjectsFolder = gui.addFolder('Viewer');
    sceneObjectsFolder.add(viewerParams, 'sceneObjectsAmount', 0, 1000000).name('Scene Objects').listen();
    sceneObjectsFolder.add(viewerParams, 'hiddenSceneObjects', 0, 1000000).name('Scene Hidden').listen();
    sceneObjectsFolder.add(viewerParams, 'linkpadsAmount', 0, 1000000).name('Linkpads').listen();
    sceneObjectsFolder.add(viewerParams, 'hiddenLinkpads', 0, 1000000).name('Linkpads Hidden').listen();


    gui.open();

    gui.hide();
}

export function showAnalytics(value) {
    if (value)
        gui.show();
    else
        gui.hide();

    gui.open();
}

export function sendMessageMonitoring({ msgCount, peak }) {
    if (!networkParams) return;

    networkParams.sendRate = msgCount;
    networkParams.sendPeak = peak;
}

export function receiveMessageMonitoring({ msgCount, peak }) {
    if (!networkParams) return;

    networkParams.receiveRate = msgCount;
    networkParams.receivePeak = peak;
}

export function communicationMonitoring(data) {
    if (!communicationParams) return;

    var { Duration, OutgoingAvailableBandwidth, RTT, RecvBitrate, RecvBytes, SendBitrate, SendBytes, UserCount } = data;

    communicationParams.duration = Duration;
    communicationParams.RTT = RTT;
    communicationParams.recvBitrate = bpsToKBps(RecvBitrate);
    communicationParams.recvBytes = bytesToKB(RecvBytes);
    communicationParams.sendBitrate = bpsToKBps(SendBitrate);
    communicationParams.sendBytes = bytesToKB(SendBytes);
    communicationParams.userCount = UserCount;
}

export function viewerMonitoring(data) {
    if (!viewerParams) return;

    var { sceneObjectsAmount, hiddenSceneObjects, linkpadsAmount, hiddenLinkpads } = data;

    viewerParams.sceneObjectsAmount = sceneObjectsAmount;
    viewerParams.hiddenSceneObjects = hiddenSceneObjects;
    viewerParams.linkpadsAmount = linkpadsAmount;
    viewerParams.hiddenLinkpads = hiddenLinkpads;

}


function bpsToKBps(bps) {
    return (bps / 8000).toFixed(1);
}

function bytesToKB(bytes) {
    return (bytes / 1024).toFixed(1);
}